/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum AdPosition {
    HOMEPAGE_1 = 'homepage_1',
    HOMEPAGE_2 = 'homepage_2',
    BLOG_1 = 'blog_1',
    BLOG_2 = 'blog_2',
    RECIPES_1 = 'recipes_1',
    RECIPES_2 = 'recipes_2',
    ABOUT_US = 'about_us',
    ACTION_OFFER_FIRST = 'action_offer_first',
    ACTION_OFFER_SECOND = 'action_offer_second',
    ACTION_OFFER_THIRD = 'action_offer_third',
    ACTION_OFFER_FOURTH = 'action_offer_fourth',
    ACTION_OFFER_PODVAL = 'action_offer_podval',
    BRANCH_1 = 'branch_1',
    BRANCH_2 = 'branch_2',
    ACTION_OFFER_LEAFLET_FIRST = 'action_offer_leaflet_first',
    ACTION_OFFER_LEAFLET_SECOND = 'action_offer_leaflet_second',
    RESTAURANT_1 = 'restaurant_1',
    FRESH_1 = 'fresh_1',
}
